import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, Button, Col, Form, Input, Row, Typography } from 'antd';

import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import { CloseOutlined } from '@ant-design/icons';

const CouponInput = () => {
    const { orderData } = QuickTurnPartStore;

    const [couponValue, setCouponValue] = useState<string>('');

    const inputRef = useRef(null);

    return (
        <div className="quickturn-coupon-wrapper">
            {orderData?.coupon ? (
                <div className="my-2">
                    <Alert
                        type="success"
                        showIcon={true}
                        message={
                            <div className="d-flex flex-row align-items-center justify-content-between">
                                <div>
                                    Coupon Code <span className="font-weight-bold">{orderData?.coupon?.code}</span>{' '}
                                    Applied to Order{' '}
                                </div>
                                <Button
                                    type="link"
                                    size="small"
                                    className="text-dark m-0 p-0"
                                    style={{ height: '24px', width: '24px' }}
                                    icon={<CloseOutlined />}
                                    onClick={() => QuickTurnPartStore.removeCoupon()}
                                />
                            </div>
                        }
                    />
                </div>
            ) : (
                <Form
                    onFinish={values => {
                        QuickTurnPartStore.setCouponError(null);
                        const uppercase = String(values.coupon_code).toUpperCase();
                        QuickTurnPartStore.applyCouponCode(uppercase);
                    }}
                    layout="vertical"
                    className="m-0"
                >
                    <Form.Item
                        className="m-0"
                        hasFeedback={Boolean(QuickTurnPartStore.couponErrors)}
                        help={QuickTurnPartStore.couponErrors}
                        validateStatus={QuickTurnPartStore.couponErrors ? 'error' : 'validating'}
                    >
                        <div className="d-flex flex-sm-row flex-column" style={{ columnGap: '0.25rem' }}>
                            <div className="flex-grow-1">
                                <Form.Item
                                    name="coupon_code"
                                    noStyle
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter a coupon code',
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter coupon code"
                                        size="small"
                                        ref={inputRef}
                                        value={couponValue}
                                        onChange={e => {
                                            const uppercase = String(e.target.value).toUpperCase();
                                            setCouponValue(uppercase);
                                        }}
                                    />
                                </Form.Item>
                            </div>

                            <div>
                                <Button type="default" htmlType="submit" block size="small">
                                    Apply Coupon
                                </Button>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            )}
        </div>
    );
};

export default observer(CouponInput);
